module.exports = {
    modules: {
        bundle: require('./modules/bundle'),
        calendars: require('./modules/calendar'),
        // inventoryManager: require("./inventory-manager"),
    },
};
